import Icon from '../components/Icon.vue'

Icon.register({
  'store-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M121.5 384h226.9l157.3 128h-414.5c-16.8 0-30.4-14.3-30.4-32v-196.8c5 1.5 10.3 2.8 15.6 3.6 5.6 0.8 11.3 1.2 17.1 1.2 9.7-0.2 19-1.5 28-3.8v99.8zM93.5 255.9c-0.1 0-0.1 0-0.1 0-4.4 0-8.7-0.3-12.9-0.9-58.9-8.5-87-81.6-56.5-135l133.5 108.6c-16.7 16.5-38.9 27.2-64 27.2zM602.1 458.1c3.6 3 5.9 7.6 5.9 12.7 0 3.7-1.2 7-3.2 9.8l-18.7 25.3c-2.7 3.7-7 6.2-12 6.2-3.5 0-6.8-1.3-9.3-3.4l-558.9-454.7c-3.6-3-5.9-7.6-5.9-12.7 0-3.7 1.2-7 3.2-9.8l18.7-25.3c2.7-3.7 7-6.2 12-6.2 3.6 0 6.8 1.3 9.4 3.4l33.7 27.4 9.4-15.8c5.2-8.9 14.7-14.9 25.7-15h383.8c11 0.1 20.6 6.1 25.7 15l61.7 103.6c31.9 53.6 3.6 128-56.1 136.4-4.3 0.6-8.6 0.9-13 0.9-28 0-52.9-13-70.1-33.1-17.1 20.1-42 33.1-70.1 33.1-8.8-0.1-17.4-1.6-25.4-4.1l137.8 112.1v-79.7c9 2.4 18.3 3.7 28 3.8 5.9 0 11.6-0.4 17.3-1.2 5.3-0.8 10.6-2 15.6-3.6v130.2z'
      }
    ]
  }
})
